import React from "react";
import { useTranslation } from "react-i18next";
import ErrorMessage from "./ErrorMessage";

const NotFound = (props) => {
  const { t } = useTranslation();
  return (
    <ErrorMessage
      showAppBar={false}
      messageType="error"
      message={t("messages.common.errors.serverConnectionError")}
    />
  );
};

export default NotFound;
